import React, { useEffect, useState } from 'react'
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import { getStorageValues } from '../../shared/CommonFunctions';
import { getApiBaseUrl } from '../../utils/apiConfig';
import FileUploadModal from '../../shared/file-upload/FileUploadModal';
import FileList from '../../shared/file-upload/FileList';

function EditCustomer({ CustomerData, sendDataToParent }) {
  const [fileList, setFileList] = useState([]);
  const [showUploadModal, setShowUploadModal] = useState(false);

  function handleChange(e) {
    const { name, value } = e.currentTarget;
    sendDataToParent({
      ...CustomerData,
      [name]: value
    });
  };

  useEffect(() => {
    if (CustomerData && CustomerData.CustomerId) {
      fetchFiles(CustomerData.CustomerId);
    }
  }, [CustomerData.CustomerId]);

  const fetchFiles = async (customerId) => {
    try {
      const response = await axios.post(getApiBaseUrl() + "/file/list", {
        entityId: customerId,
        entityType: 'customer'
      });
      if (response.status === 200) {
        const payload = response?.data?.data;
        const normalized = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.[0])
            ? payload[0]
            : [];
        setFileList(normalized);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleUploadConfirm = async ({ category, files, title }) => {
    if (!CustomerData.CustomerId) return;
    const formData = new FormData();
    formData.append('entityId', CustomerData.CustomerId);
    formData.append('entityType', 'customer');
    formData.append('fileCategory', category || 'General');
    formData.append('fileTitle', title || '');
    formData.append('UserId', getStorageValues('userId'));
    (files || []).forEach((file) => formData.append('files', file, file.name));
    try {
      await axios.post(getApiBaseUrl() + "/file/upload", formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      await fetchFiles(CustomerData.CustomerId);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDownload = (file) => {
    if (!file || !file.FileLibraryId) return;
    const url = `${getApiBaseUrl()}/file/download/${file.FileLibraryId}?inline=1`;
    window.open(url, '_blank');
  };

  const handleDelete = async (file) => {
    if (!file || !file.FileLibraryId) return;
    try {
      await axios.post(getApiBaseUrl() + "/file/delete", { fileLibraryId: file.FileLibraryId });
      await fetchFiles(CustomerData.CustomerId);
    } catch (error) {
      console.log(error);
    }
  };
  

  return (
    <>
      <div className="row">
        <div className="col-lg-8 col-sm-6 col-12 mb-3">
          <label className="form-label">Customer Name <span style={{ color: "red" }}>*</span></label>
          <input
            type="hidden"
            name="CustomerId"
            value={CustomerData.CustomerId ?? ""}
          />
          <input
            type="text"
            className="form-control"
            name="CustomerName"
            value={CustomerData.CustomerName ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-4 col-sm-6 col-12 mb-3">
          <label className="form-label">Occupation</label>
          <input
            type="text"
            className="form-control"
            name="Occupation"
            value={CustomerData.Occupation ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-4 col-sm-6 col-12 mb-3">
          <label className="form-label">Mobile No</label>
          <input
            type="text"
            className="form-control"
            name="MobileNumber"
            value={CustomerData.MobileNumber ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 col-sm-6 col-12 mb-3">
          <label className="form-label">Email</label>
          <input
            type="email"
            className="form-control"
            name="EmailId"
            value={CustomerData.EmailId ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 col-sm-6 col-12 mb-3">
          <label className="form-label">Annual Income</label>
          <input
            type="number"
            className="form-control"
            name="AnualIncome"
            value={CustomerData.AnualIncome ?? ""}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-lg-4 col-sm-6 col-12 mb-3">
          <label className="form-label">Family Member Name</label>
          <input
            type="text"
            className="form-control"
            name="FamilyMemberName"
            value={CustomerData.FamilyMemberName ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-4 col-sm-6 col-12 mb-3">
          <label className="form-label">Family Member Mobile</label>
          <input
            type="text"
            className="form-control"
            name="FamilyMemberMobileNumber"
            value={CustomerData.FamilyMemberMobileNumber ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-4 col-sm-6 col-12 mb-3">
          <label className="form-label">DOB</label>
          <input
            type="date"
            className="form-control"
            name="DOB"
            value={CustomerData.DOB ? CustomerData.DOB.substring(0,10) : ""}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="card-body px-0">
        <nav className="nav nav-style-6 nav-pills mb-3 nav-justified d-sm-flex d-block" role="tablist">
          <a className="nav-link active" data-bs-toggle="tab" role="tab" href="#customer-residential" aria-selected="true">
            Residential Address
          </a>
          <a className="nav-link" data-bs-toggle="tab" role="tab" href="#customer-office" aria-selected="false" tabIndex="-1">
            Office Address
          </a>
          <a className="nav-link" data-bs-toggle="tab" role="tab" href="#customer-references" aria-selected="false" tabIndex="-1">
            References
          </a>
        </nav>
        <div className="tab-content">
          <div className="tab-pane text-muted active show" id="customer-residential" role="tabpanel">
            <div className="row">
              <div className="col-lg-6 col-sm-6 col-12 mb-3">
                <label className="form-label">Address 1</label>
                <textarea
                  className="form-control"
                  rows="2"
                  name="AddressLine1"
                  value={CustomerData.AddressLine1 ?? ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-6 col-sm-6 col-12 mb-3">
                <label className="form-label">Address 2</label>
                <textarea
                  className="form-control"
                  rows="2"
                  name="AddressLine2"
                  value={CustomerData.AddressLine2 ?? ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-6 col-sm-6 col-12 mb-3">
                <label className="form-label">Address 3</label>
                <textarea
                  className="form-control"
                  rows="2"
                  name="AddressLine3"
                  value={CustomerData.AddressLine3 ?? ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-3 col-sm-6 col-12 mb-3">
                <label className="form-label">City</label>
                <input
                  type="text"
                  className="form-control"
                  name="City"
                  value={CustomerData.City ?? ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-3 col-sm-6 col-12 mb-3">
                <label className="form-label">State</label>
                <input
                  type="text"
                  className="form-control"
                  name="State"
                  value={CustomerData.State ?? ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-3 col-sm-6 col-12 mb-3">
                <label className="form-label">Country</label>
                <input
                  type="text"
                  className="form-control"
                  name="Country"
                  value={CustomerData.Country ?? ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-3 col-sm-6 col-12 mb-3">
                <label className="form-label">Pin No</label>
                <input
                  type="text"
                  className="form-control"
                  name="PinNumber"
                  value={CustomerData.PinNumber ?? ""}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          <div className="tab-pane text-muted" id="customer-office" role="tabpanel">
            <div className="row">
              <div className="col-lg-6 col-sm-6 col-12 mb-3">
                <label className="form-label">Address 1</label>
                <textarea
                  className="form-control"
                  rows="2"
                  name="OfficeAddressLine1"
                  value={CustomerData.OfficeAddressLine1 ?? ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-6 col-sm-6 col-12 mb-3">
                <label className="form-label">Address 2</label>
                <textarea
                  className="form-control"
                  rows="2"
                  name="OfficeAddressLine2"
                  value={CustomerData.OfficeAddressLine2 ?? ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-6 col-sm-6 col-12 mb-3">
                <label className="form-label">Address 3</label>
                <textarea
                  className="form-control"
                  rows="2"
                  name="OfficeAddressLine3"
                  value={CustomerData.OfficeAddressLine3 ?? ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-3 col-sm-6 col-12 mb-3">
                <label className="form-label">City</label>
                <input
                  type="text"
                  className="form-control"
                  name="OfficeCity"
                  value={CustomerData.OfficeCity ?? ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-3 col-sm-6 col-12 mb-3">
                <label className="form-label">State</label>
                <input
                  type="text"
                  className="form-control"
                  name="OfficeState"
                  value={CustomerData.OfficeState ?? ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-3 col-sm-6 col-12 mb-3">
                <label className="form-label">Country</label>
                <input
                  type="text"
                  className="form-control"
                  name="OfficeCountry"
                  value={CustomerData.OfficeCountry ?? ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-3 col-sm-6 col-12 mb-3">
                <label className="form-label">Pin No</label>
                <input
                  type="text"
                  className="form-control"
                  name="OfficePinNumber"
                  value={CustomerData.OfficePinNumber ?? ""}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          <div className="tab-pane text-muted" id="customer-references" role="tabpanel">
            <div className="row">
              <div className="col-lg-6 col-sm-6 col-12 mb-3">
                <label className="form-label">Reference 1 Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="Reference1Name"
                  value={CustomerData.Reference1Name ?? ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-6 col-sm-6 col-12 mb-3">
                <label className="form-label">Reference 1 Mobile</label>
                <input
                  type="text"
                  className="form-control"
                  name="Reference1MobileNumber"
                  value={CustomerData.Reference1MobileNumber ?? ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-6 col-sm-6 col-12 mb-3">
                <label className="form-label">Reference 2 Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="Reference2Name"
                  value={CustomerData.Reference2Name ?? ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-6 col-sm-6 col-12 mb-3">
                <label className="form-label">Reference 2 Mobile</label>
                <input
                  type="text"
                  className="form-control"
                  name="Reference2MobileNumber"
                  value={CustomerData.Reference2MobileNumber ?? ""}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="mb-0">Attachments</h6>
        <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setShowUploadModal(true)}>
          Upload Files
        </button>
      </div>
      <FileList files={fileList} onDownload={handleDownload} onRemove={handleDelete} showRemove={true} />

      <FileUploadModal
        show={showUploadModal}
        onClose={() => setShowUploadModal(false)}
        onConfirm={handleUploadConfirm}
      />
    </>
  )
}

export default EditCustomer